import { useLayoutEffect } from 'react';

export interface EntityFieldFilterCounts {
    matching: number;
    total: number;
}

export interface EntityFieldFilterCountReporterProps {
    matching: number;
    total: number;
    onCountsChange: (counts: EntityFieldFilterCounts) => void;
}

/** Syncs field filter counts from a child render tree to parent state (e.g. entity detail summary). */
export function EntityFieldFilterCountReporter({
    matching,
    total,
    onCountsChange,
}: EntityFieldFilterCountReporterProps): null {
    useLayoutEffect(() => {
        onCountsChange({ matching, total });
    }, [matching, total, onCountsChange]);

    return null;
}
